/**
 * Shared formatting utilities for numbers, tokens, and other display values.
 */

/**
 * Format a token count for compact display.
 * Examples: 200_000 → "200K", 1_000_000 → "1M", 128_000 → "128K"
 */
export function formatTokenCount(tokens: number): string {
  if (tokens >= 1_000_000) return `${(tokens / 1_000_000).toFixed(tokens % 1_000_000 === 0 ? 0 : 1)}M`;
  if (tokens >= 1_000) return `${(tokens / 1_000).toFixed(tokens % 1_000 === 0 ? 0 : 1)}K`;
  return String(tokens);
}
